import React from "react";
import { Helmet } from "react-helmet-async";

import SubscriptionCheckoutShellAdapter from "../SubscriptionCheckoutShellAdapter/SubscriptionCheckoutShellAdapter";

/**
 * Page wrapper for the subscription checkout.
 *
 * Owns layout (max width, padding, page title); delegates everything
 * checkout-related to the adapter. Mirrors the page-then-adapter pattern
 * used by event and product checkout so the three flows render
 * consistently inside the shared CheckoutLayout.
 */
export default function SubscriptionCheckoutPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <Helmet>
        <title>Total Access — Checkout</title>
      </Helmet>

      <SubscriptionCheckoutShellAdapter />
    </div>
  );
}
